import { observable, action, intercept } from "mobx";
import { post } from "../services/ajax.service";

class SpecialtyPerformanceStore {

  @observable specialtyDiscount = 0;
  @observable net = {};
  @observable url = "/api/v1/performaneactions/specialty";

  @action getSpecialtyBrandDiscount = async (data) => {
    this.specialtyDiscount = 0;
    try {
      let response = await post(
        `${this.url}/getSpecialtyBrandDiscount`,
        data
      );

      this.specialtyDiscount = response.data[0].AVERAGE_SPECIALTY_DISCOUNT;
    } catch (err) {
      console.log(err);
    }
  }
  @action getNetPerformance = async (data) => {
    this.net = {};
    try {
      let response = await post(
        `${this.url}/getNetPerformance`,
        data
      );

      this.net = response.data[0];
    } catch (err) {
      console.log(err);
    }
  }


}

export default SpecialtyPerformanceStore;
